<div class="content">
    <div class="text-content">
        <h1 class="title">The Future of Healthcare</h1>
        <p class="description">
            Remedy Sync is a human diagnosis database which allows any medical professional to access a patient's documents in case of emergency.
        </p>
        <div class="buttons">
            <a mat-raised-button class="purple button" routerLink="/login">Login</a>
            <a mat-raised-button class="gray button" routerLink="/about">Explore</a>
        </div>
    </div>

    <div class="image-container">
        <img src="../../assets/vectorImage.png" alt="medical image" class="image"/>
    </div>
</div>

